import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircleFaint } from '@/components/Icons/CheckCircleFaint';
import { CheckCircleSuccess } from '@/components/Icons/CheckCircleSuccess';
import { PASSWORD_MIN_LENGTH, type PasswordCriteria } from '@/utils/validation';

interface Props {
  criteria: PasswordCriteria;
}

export const PasswordRequirements: React.FC<Props> = ({ criteria }) => {
  const { t } = useTranslation();

  const requirements = [
    {
      isValid: criteria.hasMinLength,
      label: t('changePassword.reqLength', { minLength: PASSWORD_MIN_LENGTH }),
    },
    {
      isValid: criteria.hasSpecialSymbol,
      label: t('changePassword.reqSpecial'),
    },
    { isValid: criteria.hasCaseAndNumber, label: t('changePassword.reqCase') },
    { isValid: criteria.isOnlyLatin, label: t('changePassword.reqLatin') },
  ];

  return (
    <div className="flex flex-col gap-1 rounded-xl border border-divider p-3">
      {requirements.map(({ isValid, label }) => (
        <div key={label} className="flex items-center gap-2">
          {isValid && <CheckCircleSuccess className="size-4 shrink-0" />}
          {!isValid && <CheckCircleFaint className="size-4 shrink-0" />}
          <span className="text-body-13 text-subtle-foreground md:text-body-14">
            {label}
          </span>
        </div>
      ))}
    </div>
  );
};
